import { render, staticRenderFns } from "./ErrorButton.vue?vue&type=template&id=16ccbe2c&"
import script from "./ErrorButton.vue?vue&type=script&lang=js&"
export * from "./ErrorButton.vue?vue&type=script&lang=js&"
import style0 from "./ErrorButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports